import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { Calendar } from 'primereact/calendar';
import { Nullable } from "primereact/ts-helpers";

interface DateRangeInputs{
    dates: Nullable<(Date | null)[]>,
    setDates: Dispatch<SetStateAction<Nullable<(Date | null)[]>>>
}

export default function DateRange({dates, setDates}: DateRangeInputs) {
    const calenderRef = useRef(null);

    return (
        <div className="m-1">
            <div className="p-inputgroup flex-1">
                <span className="p-inputgroup-addon"><i className="pi pi-calendar"></i></span>
                <Calendar pt={{day:{}}} ref={calenderRef} required minDate={new Date(Date.now())} placeholder="Select Check-in Check-out dates" value={dates} onChange={(e) => setDates(e.value)} selectionMode="range" readOnlyInput hideOnRangeSelection />
            </div>
        </div>

    )
}